import React, { useState, useEffect, createContext, useContext, ReactNode } from 'react';

interface MouseContextType {
  x: number;
  y: number;
  scrollY: number;
}

const MouseContext = createContext<MouseContextType | null>(null);

interface MouseProviderProps {
  children: ReactNode;
}

export const MouseProvider: React.FC<MouseProviderProps> = ({ children }) => {
  const [mouse, setMouse] = useState({ x: 0, y: 0, scrollY: 0 });
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setMouse((prev) => ({ ...prev, x: e.clientX, y: e.clientY }));
    };
    const handleScroll = () => {
      setMouse((prev) => ({ ...prev, scrollY: window.scrollY }));
    };
    setMouse((prev) => ({ ...prev, scrollY: window.scrollY }));
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <MouseContext.Provider value={mouse}>{children}</MouseContext.Provider>
  );
};

export const useMouse = () => useContext(MouseContext);
